// This service is used to manage all the organisation alerts
// It contains following methods
/**
 *
 * Enable Alert @method enableAlert
 * Add Alert @method addAlert
 * Update Alert @method updateAlert
 * Delete Alert @method deleteAlert
 * Disable Alert @method disableAlert
 * Change Alert Status @method changeAlertStatus
 * List Alerts @method listAlerts
 * List Active Alerts @method activeAlerts
 * Delete Alert Recipents @method removeContacts
 *
 * Swagger @link https://dev-alerting-service.xift.com/swagger-ui.html#/
 * Supporting Document @link https://seedcloud.atlassian.net/wiki/spaces/XIFT/pages/1767571491/Proposed+APIs+LLD
 *
 * **/
import store from '../store';
import APIService from './APIService';
import config from '../../config';
const url = config.baseUrlAlertingService;

export default class AlertingService extends APIService {
  /**
   *
   * Enable Alert
   *
   */
  static enableAlert() {
    const orgId = store.state.currentlySelectedOrgId;
    this.post(`${url}/alerting/config/alert/${orgId}`, {});
  }

  /**
   *
   * List Alerts
   *
   */
  static listAlerts() {
    const orgId = store.state.currentlySelectedOrgId;
    return this.get(`${url}/alerting/config/list/alert/${orgId}`);
  }

  /**
   *
   * @param {String} id
   *
   */
  static updateAlert({ id, body }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.put(`${url}/alerting/config/alert/${orgId}/${id}`, body);
  }

  /**
   *
   * To delete an alert
   * @param {String} id
   */
  static deleteAlert({ id }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.delete(`${url}/alerting/config/alert/${orgId}/${id}`);
  }

  /**
   *
   * To disable an alert
   * @param {String} name
   */
  static disableAlert({ name }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.patch(
      `${url}/alerting/config/deactivate/alert/${orgId}/${name}`
    );
  }
  /**
   *
   * To remove contacts
   * @param {Array<Number>} alertReceiversList
   */
  static removeContacts({ alertReceiversList }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.delete(
      `${url}/alerting/config/alert/${orgId}/contacts`,
      alertReceiversList
    );
  }

  /**
   * To change the status of the alert
   *
   * @param {String} state
   * @param {String} alertId
   */
  static changeAlertStatus({ state, alertId }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.patch(
      `${url}/alerting/config/alert/${orgId}/${alertId}/${state}`
    );
  }

  /**
   * To add an alert
   * 
   * @param body 
   * Sample body->{
    "alertKPIName": "string",
    "label": "string",
    "maxAttempts": 0,
    "name": "string",
    "receiverDetails": [
        {
        "contactDetail": "string",
        "contactMode": "string",
        "id": 0
        }
    ],
    "threshold": 0,
    "thresholdType": "string",
    "throttleTime": 0,
    "throttleTimeUnit": "string",
    "timeUnit": "string",
    "type": "string"
    }
   */
  static addAlert({ body }) {
    const orgId = store.state.currentlySelectedOrgId;
    return this.post(`${url}/alerting/config/alert/${orgId}`, body);
  }

  /**
   * To get all active data types
   */
  static getActiveKPI() {
    return this.get(`${url}/alerting/data/list/kpi/active`);
  }
}
